import { Badge, Calendar, ChartColumn, Chat, Enterprise, Events, Portfolio, Star, UserFollow, UserProfile } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Матрица 2.2 «Биржа: заявки, кандидаты, офферы»: OWNER, OPS_DIRECTOR, HR — изменение; MED_DIRECTOR — чтение. */
const CLINIC_EXCHANGE = ['OWNER', 'MED_DIRECTOR', 'OPS_DIRECTOR', 'HR'] as const;

/**
 * HR-биржа (раздел 7 ТЗ, Приложение D).
 * Клиника: заявки (HR-10…12), кандидаты и карточка (HR-13, HR-14), офферы (HR-15), сотрудничества и тестовый месяц
 * (HR-16, HR-17), отзывы о врачах и подтверждения мест работы (HR-08, HR-18).
 * Врач: профиль биржи (HR-01…08), офферы и сотрудничества (HR-20), подработки и календарь (HR-21, HR-22), отзывы
 * (HR-18), сообщество (HR-30, HR-31), моя статистика (HR-19). Данные врача — его собственные (раздел 1.5), поэтому
 * разделы врача доступны роли DOCTOR в любой выбранной клинике, включая личное пространство.
 */
export const sections = [
  defineSection({
    id: 'exchange.requests',
    area: 'clinic',
    path: 'exchange/requests/*',
    roles: [...CLINIC_EXCHANGE],
    icon: Portfolio,
    titleKey: 'exchange:nav.requests',
    namespaces: ['portal'],
    navGroup: 'exchange',
    order: 10,
    tabGroup: 'hiring',
    load: () => import('./clinic/RequestsPage'),
  }),
  defineSection({
    id: 'exchange.candidate',
    area: 'clinic',
    path: 'exchange/candidates/*',
    roles: [...CLINIC_EXCHANGE],
    icon: UserFollow,
    titleKey: 'exchange:nav.candidate',
    namespaces: ['portal'],
    navGroup: 'exchange',
    order: 14,
    nav: false,
    load: () => import('./clinic/CandidatePage'),
  }),
  defineSection({
    id: 'exchange.offers',
    area: 'clinic',
    path: 'exchange/offers/*',
    roles: [...CLINIC_EXCHANGE],
    icon: Chat,
    titleKey: 'exchange:nav.offers',
    namespaces: ['portal'],
    navGroup: 'exchange',
    order: 11,
    tabGroup: 'hiring',
    load: () => import('./clinic/OffersPage'),
  }),
  defineSection({
    id: 'exchange.engagements',
    area: 'clinic',
    path: 'exchange/engagements/*',
    roles: [...CLINIC_EXCHANGE],
    icon: Enterprise,
    titleKey: 'exchange:nav.engagements',
    namespaces: ['portal'],
    navGroup: 'exchange',
    order: 12,
    tabGroup: 'hiring',
    load: () => import('./clinic/EngagementsPage'),
  }),
  defineSection({
    id: 'exchange.reviews',
    area: 'clinic',
    path: 'exchange/reviews/*',
    roles: [...CLINIC_EXCHANGE],
    icon: Star,
    titleKey: 'exchange:nav.reviews',
    namespaces: ['portal'],
    navGroup: 'exchange',
    order: 13,
    tabGroup: 'hiring',
    load: () => import('./clinic/ReviewsPage'),
  }),
  defineSection({
    id: 'exchange.doctor.profile',
    area: 'clinic',
    path: 'career/profile',
    roles: ['DOCTOR'],
    icon: UserProfile,
    titleKey: 'career:nav.profile',
    namespaces: ['exchange', 'portal'],
    navGroup: 'exchange',
    order: 100,
    tabTitleKey: 'shell:tabs.profile',
    tabGroup: 'career',
    load: () => import('./doctor/ProfilePage'),
  }),
  defineSection({
    id: 'exchange.doctor.offers',
    area: 'clinic',
    path: 'career/offers/*',
    roles: ['DOCTOR'],
    icon: Badge,
    titleKey: 'career:nav.offers',
    namespaces: ['exchange', 'portal'],
    navGroup: 'exchange',
    order: 101,
    tabGroup: 'career',
    load: () => import('./doctor/DoctorOffersPage'),
  }),
  defineSection({
    id: 'exchange.doctor.jobs',
    area: 'clinic',
    path: 'career/jobs',
    roles: ['DOCTOR'],
    icon: Calendar,
    titleKey: 'career:nav.jobs',
    namespaces: ['exchange', 'portal'],
    navGroup: 'exchange',
    order: 110,
    load: () => import('./doctor/JobsPage'),
  }),
  defineSection({
    id: 'exchange.doctor.reviews',
    area: 'clinic',
    path: 'career/reviews',
    roles: ['DOCTOR'],
    icon: Star,
    titleKey: 'career:nav.reviews',
    namespaces: ['exchange', 'portal'],
    navGroup: 'exchange',
    order: 102,
    tabGroup: 'career',
    load: () => import('./doctor/DoctorReviewsPage'),
  }),
  defineSection({
    id: 'exchange.community',
    area: 'clinic',
    path: 'community/*',
    roles: ['DOCTOR'],
    icon: Events,
    titleKey: 'community:nav.community',
    namespaces: ['exchange', 'career'],
    navGroup: 'exchange',
    order: 103,
    tabGroup: 'career',
    load: () => import('./community/CommunityPage'),
  }),
  defineSection({
    id: 'exchange.doctor.stats',
    area: 'clinic',
    path: 'career/stats',
    roles: ['DOCTOR'],
    icon: ChartColumn,
    titleKey: 'career:nav.stats',
    namespaces: ['exchange'],
    navGroup: 'me',
    order: 12,
    // Статистика профиля — блок «Профиль на бирже» в «Моей статистике» (/analytics/me); адрес оставлен для старых ссылок.
    nav: false,
    load: () => import('@/app/pages/MyStatsRedirect'),
  }),
];

